var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { detectBrowserName } from '../utils/index.js';
import { EXTENSION_DOWNLOAD_URL } from '../constants/index.js';
import detectProvider from '@portkey-v1/detect-provider';
/**
 * This method is used to check if the provided object is a Portkey provider.
 */
function isPortkeyProvider() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const provider = yield detectProvider();
            return !!provider;
        }
        catch (error) {
            return false;
        }
    });
}
const checkPortkeyExtension = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const openTarget = params === null || params === void 0 ? void 0 : params.openTarget;
    if (typeof window === 'undefined')
        return false;
    const _window = window;
    if (yield isPortkeyProvider())
        return true;
    const browserName = detectBrowserName();
    const downloadURL = EXTENSION_DOWNLOAD_URL[browserName] || EXTENSION_DOWNLOAD_URL.DEFAULT;
    _window.open(downloadURL, openTarget);
    return false;
});
export default checkPortkeyExtension;
